import { getKeys } from './getKeys'

export const generalTranslations = {
  ARE_YOU_SURE: 'Are you sure you want to do this?',
  CONFIRM: 'Confirm',
  WARNING: 'Warning',
  CANCEL: 'Cancel',
  EDIT: 'Edit',
  DELETE: 'Delete',
  SAVE: 'Save',
  FILTERS_APPLIED: 'filters applied',
  TYPE_TO_SEARCH: 'Type to search...',
  REQUIRED_MESSAGE: 'This is a required field',
  PLEASE_ENTER_FIELD_NAME: 'Please enter {{fieldName}}',
  START_TYPING: 'Start typing...',
  RESIDENT: 'resident',
  tenant: 'tenant',
  Help: 'Help',
  Settings: 'Settings',
  Reload: `We have released a new version of the Care Office! For the best user experience please update now.`,
  ClickHere: 'Refresh now',
  REMIND_ME_LATER: 'Remind me later',
  UPDATE_PROMPT_TITLE: `Don't forget a new update is available!`,
  UPDATE_PROMPT_MESSAGE:
    'Please save your work, then refresh to update. A forced refresh will occur at midnight any unsaved work will be lost.',
  FINAL_WARNING_TITLE: 'Important: Save Your Work Now!',
  FINAL_WARNING_MESSAGE:
    "We're updating Care Office to bring you new features and improvements. This update will automatically start in 10 minutes. Please save all your work immediately to avoid losing any progress. Thank you for your understanding and cooperation.",
  SUCCESS: 'Success',
  ERROR: 'Error',
  CRASH: 'Whoops! There was a crash...',
  CRASH_DESCRIPTION:
    'Don’t worry, try refreshing the page and if the problem persists contact support.',
  MFA_ENSURE:
    'To ensure the security of your account, MFA must be set up before you can proceed to the Care Office.',
  MFA_ENSURE_CLICK: 'Please click the blue button to start your set up.',
  MFA_SECURED:
    'Your account is now secured with MFA, you can proceed to the Care Office by clicking the blue button.',
  MFA_SECURED_CLICK: 'Thank you for improving the security of your account',
  REFRESH: 'Refresh',
  SET_UP_NOW: 'Set up now',
  MFA_LOCKED: 'Multi-Factor Authentication (MFA) Setup Required',
  MFA_COMPLETE: 'Multi-Factor Authentication (MFA) Setup Complete',
  MFA_LOGIN: 'Login to the Care Office',
  EXIT_WITHOUT_SAVING: 'Exit without saving',
  MODAL_TITLE: 'Changes not saved',
  MODAL_CONTENT:
    'You have unsaved changes on this page. If you leave, you will lose these changes.',
  AND_N_MORE: 'and {{ n }} more',
  INVITE_A_NEW_GROUP_DASHBOARD_USER: 'Invite a new Group Dashboard User',
  INVITE_A_NEW_TEAM_MEMBER: 'Invite a new Team Member',
  ROLE_INFO_TEXT_GROUP_DASHBOARD_USER:
    'Group Admins and Group Managers can access the group dashboard.',
  ROLE_INFO_TEXT_TEAM_MEMBER:
    'Carers can only access the Carer App, while Senior Carers have limited access to the Care Office. Admins have full access to the Care Office.',
  SITES: 'Sites',
  REQUIRED_FIELDS_ARE_MARKED_WITH: 'Required fields are marked with',
  NAME: 'Name',
  FIRST_NAME_IS_REQUIRED: 'First name is required',
  FIRST: 'First',
  LAST_NAME_IS_REQUIRED: 'Last name is required',
  LAST: 'Last',
  EMAIL_IS_REQUIRED: 'Email is required',
  SELECT_SITES: 'Select sites',
  EMAIL: 'Email',
  DELETE_PROFILE: 'Delete profile',
  ROLE: 'Role',
  ALL_SITES: 'All sites',
  ARE_YOU_SURE_TO_DELETE: `Are you sure you want to delete {{variable}} ?, if you go ahead, it can’t be undone, Once the record is gone, it’s gone for good!`,
  MAKE_SURE_TO_DELETE:
    'This team member will no longer be able to log in to the Carer App or the Care Office. Their log history will still be visible.',
  TYPE_NAME: 'To delete permanently, type their name in full.',
  LOCATION_ACCURACY: 'Location accuracy: within {{accuracy}} meters',
  ADDED_TEAM_MEMBER: 'Added a Team Member',
  ADDED_GROUP_DASHBOARD_USER: 'Added a Group Dashboard User',
  PRO_UPGRADE_TOOLTIP:
    "You've added {{count}} or more {{peopleNominative}}. To add more, upgrade to our Pro plan ",
  PRO_UPGRADE_LINK_TEXT: 'here',
  CANCELLED_SUBSCRIPTION_TOOLTIP_TEXT:
    'You have already completed a free trial. Please ',
  CANCELLED_SUBSCRIPTION_CONTACT_SUPPORT: 'contact support',
  CANCELLED_SUBSCRIPTION_TOOLTIP_SUFFIX: ' to upgrade.',
  ASSIGN_AT_LEAST_1_SAF_OFFICERS:
    'Assign at least 1 Safeguarding Officers first',
  CLOSE: 'Close',
  EDIT_PERMISSIONS:
    'You can edit these permissions via <team>Team</team> Member profiles.',
  NOMINATE_TWO_SAF_OFFICERS:
    'For clinical safety, we recommend nominating at least 2 Safeguarding officers for each site.',
  ASSIGN_AT_LEAST_1_SAF_OFFICER:
    'There must be at least 1 Safeguarding Officer active in a site',
  PREVENT_LOST_LOG_DATA:
    'This prevents against lost log data or missed safeguarding concerns.',
  TURN_OFF_SAFEGUARDING:
    'Please turn off Safeguarding logs or assign another Safeguarding Officer before removing this permission.'
}

export const generalConstants = getKeys(generalTranslations)
